import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type StackElement = FlexElement;

export interface StackProps extends FlexProps {}

export const Stack = styled(
  forwardRef<StackElement, StackProps>((props, ref) => {
    return <Flex gap="var(--spacing-gap)" {...props} ref={ref} />;
  })
).withConfig({
  displayName: 'Stack',
})``;
